import {createReducer} from "redux-act";
import { ISeasonStats, requestSeasonStatsJSONSuccess } from "modules/actions/stats";

const defaultState: Record<number, ISeasonStats> = {};

export const stats = createReducer<typeof defaultState>({}, defaultState).on(
	requestSeasonStatsJSONSuccess,
	(_, stats) => stats
);
